import { lazyLoadComponent } from '../../utils';

// TODO: remove dialectId
export default async (dialectId, extra) => {
	const namespace = 'MarkerModalCard';
	const Card = await lazyLoadComponent(namespace, 'Card');
	extra = JSON.parse(extra);

	const response = await fetch(document.getElementById("appContainer").dataset.exampleListUrl, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: JSON.stringify({
			//corpus_id: extra.corpusId,
			example_id: extra.exampleId, //PMa
			KOD_OBEC: extra.KOD_OBEC,
			KOD_COB: extra.KOD_COB,
		}),
	});
	const examples = await response.json();

	let props = {
		examples,
	};

	return new Card(props);
};
